import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useUserState } from 'contexts/auth-context';

import { Icon } from 'components/common/Elements/Elements';
import { exportPNG } from 'utils/exportPNG';
import t from 'utils/translateFunc';

import classes from './DiagramModal.module.scss';

const DiagramModal = ({ setDiagramDownload, children, onOfNotif, options }) => {
  const language = useUserState().user.language;
  useEffect(() => {
    exportPNG(
      'capture',
      'idExport',
      setDiagramDownload,
      onOfNotif,
      t('notif', 'CHART_OK', language),
      options
    );
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.modalBg} id="modal">
      <div className={classes.modalBody}>
        {children}
        <div className={classes.notif}>
          <p>{t('notif', 'CHART_DOWNLOADING', language)}</p>
          <Icon icon={'Icn_Loader'} className={classes.loaderNotif} />
        </div>
      </div>
    </div>
  );
};

DiagramModal.propTypes = {
  setDiagramDownload: PropTypes.func.isRequired,
  children: PropTypes.any,
  options: PropTypes.object,
  onOfNotif: PropTypes.func
};

export default DiagramModal;
